/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookOpen: {
  name: 'book-open';
  data: string;
} = {
  name: 'book-open',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21 5.28a2 2 0 0 0-2.485-1.94L12 4.97 5.485 3.34A2 2 0 0 0 3 5.28v11.94a2 2 0 0 0 1.515 1.94l7 1.75c.047.011.094.021.142.03a.998.998 0 0 0 .686 0c.048-.009.095-.019.142-.03l7-1.75A2 2 0 0 0 21 17.22V5.28Zm-8 13.44 6-1.5V5.28l-6 1.5v11.94ZM11 6.78l-6-1.5v11.94l6 1.5V6.78Z" fill="currentColor"/></svg>`,
};
